import { Component, input } from '@angular/core';
import { PayableTableObject } from '../../models/payable-table-object';

@Component({
  selector: 'app-unpaid-mobile',
  templateUrl: './unpaid-mobile.component.html',
  styleUrls: ['./unpaid-mobile.component.scss'],
  standalone: false,
})
export class UnpaidMobileComponent {
  everyInvoiceBelongsToSameBusinessEntity = input(true);

  invoices = input<PayableTableObject[], PayableTableObject[]>(
    [],
    { transform: invoices => [...invoices].sort((a, b) => a.entityId - b.entityId) },
  );
}
